import { render, staticRenderFns } from "./EditorPMProduct.vue?vue&type=template&id=69536cb7&"
import script from "./EditorPMProduct.vue?vue&type=script&lang=ts&"
export * from "./EditorPMProduct.vue?vue&type=script&lang=ts&"
import style0 from "./EditorPMProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports